import React from 'react';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import ClientsGrid from '../components/ClientsGrid';
import PortfolioSection from '../components/PortfolioSection';
import TestimonialsCarousel from '../components/TestimonialsCarousel';
import ProcessSection from '../components/ProcessSection';
import CreativeSkillsSection from '../components/CreativeSkillsSection';
import FAQSection from '../components/FAQSection';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen overflow-x-hidden">
      <Navbar />
      <HeroSection />
      <ClientsGrid />
      <PortfolioSection />
      <TestimonialsCarousel />
      <ProcessSection />
      <CreativeSkillsSection />
      <FAQSection />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default Home;